import { render } from "./CalendarList.vue?vue&type=template&id=2e197ce8&ts=true"
import script from "./CalendarList.vue?vue&type=script&lang=ts"
export * from "./CalendarList.vue?vue&type=script&lang=ts"

import "./CalendarList.vue?vue&type=style&index=0&id=2e197ce8&lang=scss"

import exportComponent from "/builds/witteveenbos/witteveenbos-light-modules/corporate-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__